/*********************** Custom JS for Boost AI Search & Discovery  ************************/
// componentRegistry.useComponentPlugin("CollectionHeader.HeaderImage", {
//      name: "Change image resolution",
//      enabled: true,
//      apply: () => ({
//         props: (props) => {
//          props.deviceSizes = [1000]; 
//          props.imageSizes = [800];
//          return props;
//        },
//      }),
//    });
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat((registry) => {
    registry.useModulePlugin('FilterAPI', {
        name: 'Update query params for multi-currencies case',
        apply(builder) {
            builder.on('beforeMethodCall', 'get', (payload) => {
                if (boostSDAppConfig?.generalSettings?.collection_id == 282994016395) {
                    payload.args[0].currency = boostSDAppConfig?.generalSettings?.current_currency ? boostSDAppConfig.generalSettings.current_currency.toLowerCase() : Shopify.currency.active.toLowerCase();
                    payload.args[0].currency_rate = Shopify.currency.rate;
                    payload.args[0].return_all_currency_fields = false;
                }
            });
        },
    });
    registry.useModulePlugin('SearchAPI', {
        name: 'Update query params for multi-currencies case',
        apply(builder) {
            builder.on('beforeMethodCall', 'get', (payload) => {
                // Custom code goes here
                let args = payload.args
                if (args[0]) {
                    args[0].currency = boostSDAppConfig?.generalSettings?.current_currency ? boostSDAppConfig.generalSettings.current_currency.toLowerCase() : Shopify.currency.active.toLowerCase();
                    args[0].currency_rate = Shopify.currency.rate;
                    args[0].return_all_currency_fields = false;
                }
                payload.args = args;
                // console.log(payload)
            });
        },
    });
});